(function () {
  var el = document.querySelector('.sitya-countdown');
  if (!el) return;

  function pad(n) { return String(n).padStart(2, '0'); }

  // End-Zeit JEDES Tick frisch aus dem Attribut lesen -> Self-Correct-Layer kann sie aendern
  function getLabel() {
    var v = el.getAttribute('data-global-discount-end');
    var endTime = v ? new Date(v).getTime() : NaN;
    if (isNaN(endTime)) return null;
    window.sityaDiscountEnd = endTime;
    var diff = endTime - Date.now();
    if (diff <= 0) return null;
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000)  / 60000);
    var s = Math.floor((diff % 60000)    / 1000);
    return pad(d) + ':' + pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  /* Hide an expired banner countdown without changing its layout space.
     Keep ticking so a new valid end date restores the countdown automatically. */
  function tickBanner() {
    var label = getLabel();
    el.textContent = label || '00:00:00:00';
    el.style.visibility = label ? '' : 'hidden';
  }

  /* Cart-Drawer + Karten-Pill Counter */
  function updateAllCountdowns() {
    var label = getLabel();
    if (!label) return;
    document.querySelectorAll('.sitya-cart-countdown, .sitya-pill-counter').forEach(function (node) {
      node.textContent = label;
    });
  }

  tickBanner();
  updateAllCountdowns();
  setInterval(function () {
    tickBanner();
    updateAllCountdowns();
  }, 1000);

  /* MutationObserver: neue Counter-Elemente sofort befuellen */
  var observer = new MutationObserver(function (mutations) {
    var needsCountdown = false;
    var needsValidity  = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.classList && (node.classList.contains('sitya-cart-countdown') || node.classList.contains('sitya-pill-counter'))) ||
          (node.querySelector && (node.querySelector('.sitya-cart-countdown') || node.querySelector('.sitya-pill-counter')))
        ) { needsCountdown = true; }
        if (
          (node.classList && node.classList.contains('sitya-cart-validity-wrap')) ||
          (node.querySelector && node.querySelector('.sitya-cart-validity-wrap'))
        ) { needsValidity = true; }
      }
    }
    if (needsCountdown) updateAllCountdowns();
    if (needsValidity)  window.SITYA_initCartValidity(document);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  /* ── Cart Validity: Gültig-Hinweis + Countdown ── */
  function pad2(n) { return String(n).padStart(2, '0'); }

  window.SITYA_initCartValidity = function (root) {
    root = root || document;
    root.querySelectorAll('.sitya-cart-validity-wrap').forEach(function (wrap) {
      /* Alten Timer loeschen — verhindert doppelte Intervalle */
      if (wrap._sityaValidityTimer) {
        clearInterval(wrap._sityaValidityTimer);
        wrap._sityaValidityTimer = null;
      }
      var vh = wrap.querySelector('.sitya-cart-validity-hint[data-end]');
      var cd = wrap.querySelector('.sitya-cart-validity-countdown[data-end]');
      if (!vh || !cd) return;
      var endMs = parseInt(vh.getAttribute('data-end'), 10);
      if (!endMs || endMs <= Date.now()) return;

      /* Gültig-Text */
      var now     = new Date();
      var today0  = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var endDate = new Date(endMs);
      var end0    = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
      var diff    = Math.round((end0 - today0) / 86400000);
      var text;
      if (diff <= 0)     { text = 'Nur mehr heute gültig!'; }
      else if (diff ===1){ text = 'Nur mehr bis morgen gültig!'; }
      else {
        text = 'Nur gültig bis ' + pad2(endDate.getDate()) + '.' + pad2(endDate.getMonth() + 1) + '.' + endDate.getFullYear() + '!';
      }
      vh.textContent  = text;
      vh.style.display = 'block';

      /* Countdown */
      var valEl = cd.querySelector('.sitya-cart-validity-countdown__value');
      if (!valEl) return;
      cd.style.display = 'flex';
      function tick() {
        var r = endMs - Date.now();
        if (r <= 0) {
          cd.style.display = 'none';
          clearInterval(wrap._sityaValidityTimer);
          wrap._sityaValidityTimer = null;
          return;
        }
        valEl.textContent =
          pad2(Math.floor(r / 86400000)) + ':' +
          pad2(Math.floor((r % 86400000) / 3600000)) + ':' +
          pad2(Math.floor((r % 3600000)  / 60000)) + ':' +
          pad2(Math.floor((r % 60000)    / 1000));
      }
      tick();
      wrap._sityaValidityTimer = setInterval(tick, 1000);
    });
  };

  /* Initialer Load */
  window.SITYA_initCartValidity(document);

  /* Re-Init nach Cart-Events (AJAX-Drawer-Update) */
  ['cart:update', 'cart:updated', 'cart:change', 'cart:changed', 'cart:refresh', 'on:cart:update']
    .forEach(function (ev) {
      document.addEventListener(ev, function () {
        setTimeout(function () { window.SITYA_initCartValidity(document); }, 80);
      });
    });
})();
